import { useState } from "react";
import { Send, Check } from "lucide-react";
import { toast } from "sonner";
import { shareTestimonial } from "@/lib/testimonials";
import { errorText } from "@/lib/family";

export const ShareExperience = () => {
  const [quote, setQuote] = useState("");
  const [name, setName] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await shareTestimonial({ quote: quote.trim(), display_name: name.trim(), consent: true }); setSent(true); }
    catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };

  return (
    <section className="pp-card max-w-lg mt-6" data-testid="share-experience">
      <p className="pp-label">Share your experience</p>
      <h2 className="pp-h2">How is NICE helping your family?</h2>
      {sent ? (
        <p className="pp-reward gold mt-3" data-testid="share-experience-thanks"><Check className="inline h-4 w-4" /> Thank you! We'll review it before it's shared.</p>
      ) : (
        <form onSubmit={submit} className="grid gap-2" data-testid="share-experience-form">
          <textarea className="pp-textarea" rows={4} maxLength={500} value={quote} onChange={(e) => setQuote(e.target.value)}
            placeholder="A sentence or two about what's changed at home…" data-testid="share-experience-quote" />
          <input className="pp-input" style={{ marginTop: 8 }} maxLength={60} value={name} onChange={(e) => setName(e.target.value)}
            placeholder="How should we name you? e.g. Sarah M., mom of two" data-testid="share-experience-name" />
          <label className="flex gap-2 items-start text-sm mt-2">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1" data-testid="share-experience-consent" />
            I agree that BurrHaus Counseling, LLC. may share this quote and name in NICE and its marketing.
          </label>
          <button className="pp-primary mt-2 w-fit" disabled={busy || quote.trim().length < 10 || !name.trim() || !consent} data-testid="share-experience-submit">
            <Send className="h-5 w-5" /> Send
          </button>
        </form>
      )}
    </section>
  );
};
